import { render } from "./kgb-prediksi-list-custom.vue?vue&type=template&id=348b0d90"
import script from "./kgb-prediksi-list-custom.vue?vue&type=script&lang=js"
export * from "./kgb-prediksi-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__